// Helpers for admin CRUD UI — shared formatting + select options.
export const fmtDate = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toISOString().slice(0, 10); } catch { return iso; }
};

export const fmtPrice = (n) => {
  if (n == null) return '—';
  return '₹ ' + Number(n).toLocaleString('en-IN');
};

export const PAYMENT_STATUSES = ['pending', 'manual', 'paid', 'failed', 'refunded'];
export const ACCESS_STATUSES = ['active', 'paused', 'revoked'];
